import { getLang } from '@/utils/index'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { useLangPrefix as useLangPrefixDefault } from '@gateio/core-lib'
import { useStore } from '@/store/index'

const useLangPrefix = () => {
  const router = useRouter()
  const subWebsiteId: number = useStore().globalStore?.commonData?.sub_website_id ?? 0

  // const langPrefix = useMemo(() => {
  //   // 在客户端渲染时根据路由语言获取语言前缀
  //   if (router.locale) {
  //     const lang = getLang(router.locale) === 'en' ? '' : `/${getLang(router.locale)}`.toLocaleLowerCase()
  //     return formatLang(lang)
  //   }
  //   // 在服务器端渲染时直接返回默认的语言前缀
  //   return ''
  // }, [router.locale])

  const langPrefix = useLangPrefixDefault(subWebsiteId)

  const isZh = useMemo(() => {
    return ['zh', 'cn', 'zh-tw', 'tw'].includes(getLang(router.locale).toLocaleLowerCase())
  }, [router.locale])

  const isAr = useMemo(() => {
    return ['ar'].includes(getLang(router.locale).toLocaleLowerCase())
  }, [router.locale])

  return { langPrefix: langPrefix?.toLocaleLowerCase(), isZh, isAr }
}

export default useLangPrefix
